// removed by extract-text-webpack-plugin
module.exports = {"wrap":"_2vWYIQlOVSvUdlwU2QK2r","container":"_2p_jnznEuq61MZOWxAuQQc"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/Modal/Modal.css
// module id = 968
// module chunks = 58